import { LOAD_EMENDAS, CLEAR_EMENDAS, SET_YEAR, EMENDAS_TOGGLE_LOADING } from '.'

const INITIAL_STATE = []
export const mutations = {
  [LOAD_EMENDAS]: (state, payload) => {
    state.emendas = payload
  },
  [SET_YEAR]: (state, payload) => {
    state.ano = payload
  },
  [CLEAR_EMENDAS]: state => {
    state.emendas = INITIAL_STATE
  },
  [EMENDAS_TOGGLE_LOADING]: state => {
    state.loading = !state.loading
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/emendas_parlamentares/mutations.js